import { createContext, useContext } from 'react'

export const RefillContext = createContext({})

export const useRefillContext = () => {
  const value = useContext(RefillContext)
  return {
    ...value,
  }
}
